import React from "react";
import styled from "styled-components";
import { Icon, IconButton } from "@material-ui/core";

import { FlexLayout } from "js/Components/FlexLayout";
import { TextContent } from "js/Components/TextContent";
import { TextField } from "js/Components/TextField";

const InputContainer = styled.div<{ isValidUrl: boolean }>`
    color: ${props => props.isValidUrl ? "#222" : "orangered"};
    width: 100%;
    
    > div.MuiFormControl-root {
        width: 100%;
    }
`;

export default function WebPageContextInput(props: { url: string, onUrlChange: (url: string | null) => void }) {
    const { url, onUrlChange } = props;

    const [rawUrl, setRawUrl] = React.useState<string>(url);
    const [isValidUrl, setIsValidUrl] = React.useState<boolean>(false);
    const [isExcludedDomain, setIsExcludedDomain] = React.useState<boolean>(false);

    const validateUrl = (url: string) => {
        // check if url is valid
        let isValidUrl = true;
        try {
            if (!url) isValidUrl = false;
            const parsedUrl = new URL("https://" + url);
            isValidUrl = parsedUrl.protocol === "http:" || parsedUrl.protocol === "https:";
        } catch {
            isValidUrl = false;
        }

        // check against excluded domains
        const excludedDomains = ["linkedin.com"];
        const isExcluded = excludedDomains.some(domain => url.includes(domain));

        return { isValidUrl, isExcluded };
    }

    const onRawUrlChange = (newUrl: string) => {
        const url = newUrl.replace(/https?:\/\//, ""); // remove http:// or https://
        setRawUrl(url);

        const { isValidUrl, isExcluded } = validateUrl(url);
        if (!isValidUrl) {
            setIsValidUrl(false);
        } else if (isExcluded) {
            setIsExcludedDomain(true);
        } else {
            setIsValidUrl(true);
            setIsExcludedDomain(false);
        }
    }

    const onRawUrlChangeBlur = () => {
        const { isValidUrl, isExcluded } = validateUrl(rawUrl);

        if (isValidUrl && !isExcluded) {
            onUrlChange(`https://${rawUrl}`);
        }
    }

    return (
        <FlexLayout direction="column" gap={10}>
            <FlexLayout align="center" alignSelf="stretch" border="1px solid #EEE" height={38} padding="7px 6px 7px 12px" gap={10}>
                <Icon style={{ color: "#666" }}>language</Icon>
                <TextContent center>https://</TextContent>
                <InputContainer isValidUrl={isValidUrl}>
                    <TextField
                        value={rawUrl}
                        onChange={onRawUrlChange}
                        onBlur={onRawUrlChangeBlur}
                        placeholder={"Type URL..."}
                        InputProps={{ disableUnderline: true }}
                    />
                </InputContainer>
                <IconButton size="small" onClick={() => onUrlChange(null)}>
                    <Icon fontSize="small">close</Icon>
                </IconButton>
            </FlexLayout>

            {isExcludedDomain && (
                <TextContent error>
                    This domain or url is not available to use for AI context. You can copy the text from the spage and paste into the text content instead
                </TextContent>)}

            <TextContent note>Webpages must be publicly available and not require authentication or cookies.</TextContent>
        </FlexLayout>

    );
}